var render = function () {
  var _vm$state$parseExtraI, _vm$item$textImgInfo;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.item.normalImgInfo ? _c('div', [_c('img', {
    staticClass: "image",
    style: _vm.imgStyle,
    attrs: {
      "src": _vm.item.normalImgInfo[_vm.imageType]
    }
  })]) : _vm.item.textImgInfo ? _c('div', {
    staticClass: "text_container",
    style: Object.assign({
      background: ((_vm$state$parseExtraI = _vm.state.parseExtraInfo) === null || _vm$state$parseExtraI === void 0 ? void 0 : _vm$state$parseExtraI.color) || 'rgba(230, 223, 213, 1)'
    }, _vm.imgStyle)
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(((_vm$item$textImgInfo = _vm.item.textImgInfo) === null || _vm$item$textImgInfo === void 0 ? void 0 : _vm$item$textImgInfo.desc) || ''))])]) : _c('div', [_c('img', {
    staticClass: "image",
    style: _vm.imgStyle,
    attrs: {
      "src": _vm.defaultErrImage
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }